import type * as React from 'react'

import { cn } from '@/shared/helpers/styles.helper'

import GoogleLogo from './assets/google.svg'
import TrustpilotLogo from './assets/trustpilot.svg'

type Props = Omit<React.ComponentProps<'div'>, 'title'> & {
  // Sentence above or before the ratings
  title: React.ReactNode
  titleClassName?: string
  // Ratings already formatted for the locale
  ratings: { trustpilot: string; google: string }
}

// Rating of a review site, after its logo
const Rating = ({
  logo,
  rating
}: {
  logo: React.ReactNode
  rating: string
}) => (
  <div className='flex items-center gap-2'>
    {logo}
    <span className='font-bold text-primary'>{rating}</span>
  </div>
)

// Sentence of trust and ratings of SeDomicilier on Trustpilot and Google: stacked on mobile, on one line from tablet
export function Reviews({
  title,
  titleClassName,
  ratings,
  className,
  ...props
}: Props) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 md:flex-row md:gap-4',
        className
      )}
      {...props}
    >
      <p
        className={cn(
          'text-center text-sm leading-5 font-semibold text-[color:var(--gray-800)] md:text-base',
          titleClassName
        )}
      >
        {title}
      </p>
      <div className='flex flex-wrap items-center justify-center gap-x-4 text-base leading-5'>
        <Rating
          logo={
            <TrustpilotLogo
              role='img'
              aria-label='Trustpilot'
              className='h-6 w-auto md:h-[30px]'
            />
          }
          rating={ratings.trustpilot}
        />
        <Rating
          logo={
            <GoogleLogo
              role='img'
              aria-label='Google'
              className='h-6 w-auto md:h-[30px]'
            />
          }
          rating={ratings.google}
        />
      </div>
    </div>
  )
}
